import { DeleteOutlined, DownloadOutlined, DownOutlined, EditOutlined, EyeOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, ConfigProvider, Input, Pagination, Select } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import useDebounce from '../../../hook/useDebounce';
import useToast from '../../../hook/useToast';
import Layout from '../../../Layout';
import './style.scss';

import viVN from 'antd/locale/vi_VN';
import useThrottle from '../../../hook/useThrottle';

import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { PaginationProps } from 'antd/es/pagination/Pagination';
import { useSelector } from 'react-redux';
import { deleteProduct, getInfoProduct, IProduct, updateActiveProduct } from '../../../api/carProduct/carProductApi';
import { NodataTable } from '../../../components/NoDataTable';
import useLoading from '../../../hook/useLoading';
import { selectorMenu } from '../../../store/slices/menuSlice';
import { dataPagination, findChildIdByUrl } from '../../../until';
import StatusCellRenderer from '../VehicleTypeManagement/Component/StatusCellRenderer';
import ModalCreate from './Component/Modal/ModalCreate';
import ModalEdit from './Component/Modal/ModalEdit';
import ModalView from './Component/Modal/ModalView';
import { formatNumber } from '../../../services/mixin';


interface IDataDefaulFilterList {
  search?: string;
  carLineId?: number
  typeVehicleId?: number
  groupVehicleId?: number
}
const dataDefaulFilterList = {

};



const ProductManagement: React.FC = () => {
  useEffect(() => {

    return () => {
      setDataFilterList(dataDefaulFilterList)
      setPagination({ current: 1, pageSize: 20, total: 0 })
      setSelectedRowKeys([])
    }
  }, [])



  const pushToast = useToast();
  const pushLoading = useLoading()
  const menuSlice = useSelector(selectorMenu)
  const { add, edit, delete: isdelete, download, upload } = findChildIdByUrl(menuSlice, "/vehicle-management/brand-management")

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [openModalUpload, setOpenModalUpload] = useState(false);

  // bộ lọc
  const [filterCarLines, setFilterCarLines] = useState<{ value: number, label: string }[]>([])
  const [filterTypeVehicle, setFilterTypeVehicle] = useState<any[]>([])

  const [isOpenModalAdd, setIsOpenModalAdd] = useState(false)
  const [isOpenModalView, setIsOpenModalView] = useState(false)
  const [isOpenModalEdit, setIsOpenModalEdit] = useState(false)
  const [isModalDelete, setIsModalDelete] = useState(false)

  const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const [idChose, setIdChose] = useState<number[]>();

  const [infoProduct, setInfoProduct] = useState<IProduct>()

  const [listProduct, setListProduct] = useState<IProduct[]>([])

  const actionColumn: ColDef = {
    headerName: 'Hành động',
    headerComponentParams: {
      template: '<span class="w-full flex items-center justify-center">Hành động</span>'
    },
    field: 'action',
    colId: 'action',
    width: 180,
    resizable: false,
    suppressMovable: true,
    lockPosition: 'left',
    cellRenderer: (params: any) => {
      const id = params.data.id
      return (
        <div className='d-flex gap-4 justify-start align-center  h-full'>
          <EyeOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
            onClick={() => gInfoProduct(id)}
          />
          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
            onClick={() => gInfoProduct(id, false)}
          />
          <DeleteOutlined
            className={`text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
            onClick={() => openModalDelete(Number(id))}
          />
        </div>

      )
    },
  }

  const columnDefs = useMemo<ColDef<any>[]>(() =>
    [
      actionColumn,
      {
        headerName: "Dòng xe",
        field: "carLineTitle",
        flex: 1
      },
      {
        headerName: "Loại xe",
        field: "typeVehicleTitle",
        flex: 1
      },

      {
        headerName: "Nhóm sản phẩm",
        field: "groupVehicleTitle",
        flex: 1
      },
      {
        headerName: "Mã sản phẩm",
        field: "code",
        flex: 1
      },

      {
        headerName: "Sản phẩm",
        field: "title",
        flex: 1
      },

      {
        headerName: "Trạng thái",
        field: "status",

        cellRenderer: StatusCellRenderer,
        cellRendererParams: {
          onToggle: (id: number, isActive: boolean) => uActiveProduct(id, isActive),
          idKey: 'id',
        },
        flex: 1
      },
    ], [pagination]);

  const gListProduct = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    // pushLoading(true)
    const { search, carLineId, typeVehicleId, groupVehicleId } = dataFilterList
  }, 1000)

  const gInfoProduct = useThrottle(async (id: number, isview: boolean = true) => {
    pushLoading(true)
    const result = await getInfoProduct(
      id
    )
    if (result?.status) {
      setInfoProduct(result.data)
      if (isview)
        setIsOpenModalView(true)
      else
        setIsOpenModalEdit(true)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const uActiveProduct = useThrottle(async (id: number, isActive: boolean) => {
    pushLoading(true)
    const result = await updateActiveProduct(
      id
    )
    if (result?.status) {
      gListProduct(pagination.current, pagination.pageSize)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsOpenModalAdd(false)
      pushToast(message, "success")
      gListProduct(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalEdit = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsOpenModalEdit(false)
      pushToast(message, "success")
      gListProduct(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalDelete = async () => {
    if (!idChose) return
    pushLoading(true)
    const result = await deleteProduct(idChose)
    if (result.status) {
      setIsModalDelete(false)
      pushToast(result.message, "success")
      gListProduct(pagination.current, pagination.pageSize)
    } else {
      pushToast(result.message, "error")
    }
    pushLoading(false)
  }

  const openModalDelete = (id: number) => {
    setIdChose([id])
    setIsModalDelete(true)
  }

  const closeModalDelete = () => {
    setIdChose(undefined)
    setIsModalDelete(false)
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListProduct(pageNumber, pageSize)
  }

  useEffect(() => {
    gListProduct()
  }, [dataFilterList])

  return (

    <Layout>
      <ModalCreate
        isOpen={isOpenModalAdd}
        onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setIsOpenModalAdd(false)}
      />

      <ModalView
        isOpen={isOpenModalView}
        infoProduct={infoProduct}
        closeModal={() => setIsOpenModalView(false)}
      />

      <ModalEdit
        isOpen={isOpenModalEdit}
        infoProduct={infoProduct}
        onSubmitFormModal={onSubmitFormModalEdit}
        closeModal={() => setIsOpenModalEdit(false)}
      />

      <ModalDeleteManager
        isOpen={isModalDelete}
        title="Bạn có chắc chắn xóa sản phẩm này"
        titleDelete="Xóa sản phẩm"
        content="Sản phẩm và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
        onConfirm={onSubmitFormModalDelete}
        closeModal={closeModalDelete}
      />

      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Quản lý xe</a>,
          },
          {
            title: 'Quản lý sản phẩm',
          },
        ]}
      />
      <div className='title-page'>
        Quản lý sản phẩm
      </div>
      <div className='d-flex gap-3 pb-18-px brand-management-filter'>
        <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
          <Input
            placeholder="Tìm kiếm theo tên sản phẩm"
            className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
            value={dataFilterList.search}
            onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
          />
          <div className=" border-l-F2F4F7 h-full d-flex align-center">
            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
          </div>
        </div>
        <div className='d-flex align-center gap-2'>
          <div className="w-200-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
            <div className="d-flex align-center  w-full">
              <Select
                showSearch
                allowClear
                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                popupClassName='position-dropdow custome-select-item h-popUp'
                variant="borderless"
                placeholder="Chọn dòng xe"
                suffixIcon={null}
                options={filterCarLines}
                value={dataFilterList.carLineId}
                onChange={(e) => setDataFilterList({ ...dataFilterList, carLineId: e })}
              />

            </div>
            <div className="  h-full d-flex align-center">
              <DownOutlined className="text-sm text-98A2B3 " />
            </div>
          </div>
        </div>
        <div className='d-flex align-center gap-2'>
          <div className="w-200-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
            <div className="d-flex align-center  w-full">
              <Select
                showSearch
                allowClear
                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                popupClassName='position-dropdow custome-select-item h-popUp'
                variant="borderless"
                placeholder="Chọn loại xe"
                suffixIcon={null}
                options={filterTypeVehicle}
                value={dataFilterList.typeVehicleId}
                onChange={(e) => setDataFilterList({ ...dataFilterList, typeVehicleId: e })}
              />

            </div>
            <div className="  h-full d-flex align-center">
              <DownOutlined className="text-sm text-98A2B3 " />
            </div>
          </div>
        </div>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-106-px py-2 px-4 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${!download && "disabled"}`}
        >
          <DownloadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Xuất DS</span>
        </button>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-111-px py-2 px-4 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${!upload && "disabled"}`}
          onClick={() => setOpenModalUpload(true)}
        >
          <UploadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Nhập DS</span>
        </button>
        <button className={`border-none bg-096DD9 rounded-6-px  py-2 px-4 h-8 d-flex justify-center align-center gap-10-px w-107-px ${!add && "disabled"}`}
          onClick={() => setIsOpenModalAdd(true)}
        >
          <PlusOutlined className='text-sm text-white' />
          <span className='text-sm fw-400 font-regular text-white white-space-nowrap'>Tạo mới</span>
        </button>
      </div>
      <div className="t-table-block  custom-page-css flex flex-col flex-1 justify-between">
        <div className="ag-theme-alpine custom-table-ag custom-brand-table" style={{ width: '100%' }}>
          <AgGridReact
            rowSelection="multiple"
            rowData={listProduct}
            columnDefs={columnDefs}
            domLayout="autoHeight"
            className="my-auto-height-grid"
            rowHeight={55}
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}

            />
          </div>
        </ConfigProvider>
      </div>
    </Layout>

  );
}

export default ProductManagement;
